import { TCityParam, TForm } from "@containers/LandingPage/type";
import callAPI from "@helpers/network";
import InterestFormServices from "@services/interest-form";

export const INTEREST_FORM_SERVICES = {
  POST_INTEREST_FORM: async (data: Partial<TForm>, clientToken?: string, lang?: string) => {
    return callAPI(InterestFormServices.PostInterestFormService(data, clientToken, lang));
  },
  GET_INDUSTRY_DATA: async (lang: string) => {
    return callAPI(InterestFormServices.GetIndustryService(lang), true);
  },
  GET_COUNTRY_DATA: async (token: string) => {
    return callAPI(InterestFormServices.GetCountryService(token), true);
  },
  GET_CITY_DATA: async (param: TCityParam) => {
    return callAPI(InterestFormServices.GetCityService(param), true);
  },
  GET_COMPANY_SIZE: async (lang: string) => {
    return callAPI(InterestFormServices.GetCompanySize(lang));
  },
  POST_EMAIL_CHECKING: async (payload: { email: string }, token: string, clientToken?: string) => {
    return callAPI(InterestFormServices.PostEmailChecking(payload, token, clientToken));
  },
  POST_SUBMIT_EMAIL_VERIFY: async (
    payload: Partial<TForm>,
    token: string,
    clientToken?: string,
  ) => {
    return callAPI(InterestFormServices.PostSubmitEmailVerify(payload, token, clientToken));
  },
  POST_EMAIL_VERIFICATION: (
    payload: { signatureCode: string | string[] | undefined },
    token: string,
    clientToken?: string,
  ) => {
    return callAPI(InterestFormServices.PostEmailVerification(payload, token, clientToken));
  },
};
